"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbSessionStorage = void 0;
class MbSessionStorage {
    constructor(storage) {
        this.getSavedSessionData = () => {
            const username = this.storage.getItem('username');
            const savedExpiresIn = this.storage.getItem('expiresIn');
            const expiresIn = savedExpiresIn ? Number(savedExpiresIn) : 0;
            const savedSessionExpiresAt = this.storage.getItem('sessionExpiresAt');
            const sessionExpiresAt = (savedSessionExpiresAt === null || savedSessionExpiresAt === void 0 ? void 0 : savedSessionExpiresAt.trim()) ? new Date(savedSessionExpiresAt) : null;
            const accessToken = this.storage.getItem('accessToken');
            const refreshToken = this.storage.getItem('refreshToken');
            const savedTimeOutStamp = this.storage.getItem('timeOutStamp');
            const timeOutStamp = savedTimeOutStamp ? Number(savedTimeOutStamp) : 0;
            const customerSessionId = this.storage.getItem('customerSessionId');
            return username && accessToken && refreshToken
                ? {
                    username,
                    expiresIn,
                    sessionExpiresAt,
                    accessToken,
                    refreshToken,
                    timeOutStamp,
                    customerSessionId,
                }
                : null;
        };
        this.storage = storage;
    }
    checkSecurityData(data) {
        return (data === null || data === void 0 ? void 0 : data.accessToken) && (data === null || data === void 0 ? void 0 : data.refreshToken) && (data === null || data === void 0 ? void 0 : data.username);
    }
    checkExpiresData(data) {
        return (data === null || data === void 0 ? void 0 : data.expiresIn) && (data === null || data === void 0 ? void 0 : data.timeOutStamp);
    }
    checkSecurityAndExpiration(data) {
        return Boolean(this.checkSecurityData(data) && this.checkExpiresData(data));
    }
    saveSessionData(newData) {
        var _a, _b, _c;
        if (this.checkSecurityAndExpiration(newData)) {
            this.storage.setItem('username', newData.username);
            this.storage.setItem('expiresIn', ((_a = newData.expiresIn) === null || _a === void 0 ? void 0 : _a.toString()) || '');
            this.storage.setItem('sessionExpiresAt', ((_b = newData.sessionExpiresAt) === null || _b === void 0 ? void 0 : _b.toISOString()) || '');
            this.storage.setItem('accessToken', newData.accessToken);
            this.storage.setItem('refreshToken', newData.refreshToken);
            this.storage.setItem('timeOutStamp', ((_c = newData.timeOutStamp) === null || _c === void 0 ? void 0 : _c.toString()) || '');
            this.storage.setItem('customerSessionId', newData.customerSessionId || '');
        }
    }
    removeSavedSessionData() {
        this.storage.removeItem('username');
        this.storage.removeItem('expiresIn');
        this.storage.removeItem('sessionExpiresAt');
        this.storage.removeItem('accessToken');
        this.storage.removeItem('refreshToken');
        this.storage.removeItem('timeOutStamp');
        this.storage.removeItem('customerSessionId');
    }
}
exports.MbSessionStorage = MbSessionStorage;
//# sourceMappingURL=sessionStorage.js.map